import { ProductPayload, UploadRequest } from '../types/product.types';

export const processPayload = (data: UploadRequest): UploadRequest => {
	const processedData = { ...data };

	if (processedData.arquivo) {
		processedData.arquivo = processedData.arquivo.map(
			(item: ProductPayload) => {
				const processedItem: ProductPayload = {
					codigo_produto: item.codigo_produto,
					nome_produto: item.nome_produto,
				};

				// Adiciona campos opcionais apenas se não estiverem vazios
				if (isValidValue(item.custo_produto)) {
					processedItem.custo_produto = item.custo_produto;
				}
				if (isValidValue(item.nome_familia)) {
					processedItem.nome_familia = item.nome_familia;
				}
				if (isValidValue(item.nome_modelo)) {
					processedItem.nome_modelo = item.nome_modelo;
				}
				if (isValidValue(item.nome_sub_familia)) {
					processedItem.nome_sub_familia = item.nome_sub_familia;
				}
				if (isValidValue(item.participa_rateio)) {
					processedItem.participa_rateio = item.participa_rateio;
				}
				if (isValidValue(item.status)) {
					processedItem.status = item.status;
				}

				// Campos de controle (sempre enviados se existirem)
				if (item.numero_linha) {
					processedItem.numero_linha = item.numero_linha;
				}
				if (item.arquivo_tag) {
					processedItem.arquivo_tag = item.arquivo_tag;
				}

				return processedItem;
			}
		);
	}

	return processedData;
};

const isValidValue = (value: any): boolean => {
	return value !== undefined && value !== null && value !== '';
};
